module.exports = __webpack_public_path__ + "static/img/hy_03.d72e2d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hy_03.png
// module id = hQe3
// module chunks = 0